import Plan from './Plan'

export default Plan
